var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM13.1899 10.9757V20.8869C13.1899 21.8649 14.3133 22.4119 15.0879 21.8113L21.7757 16.606C22.3996 16.1217 22.3767 15.1682 21.7334 14.7057L15.0457 9.9468C14.2653 9.3984 13.1899 10.0111 13.1899 10.9757Z","fill":"white"}));
}

Play.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Play;

Play.default = Play;
